export const cities = {
  getCities: "geo/cities",
};
